
import { createSlice } from '@reduxjs/toolkit';
import { SearchOutputFileInput } from '../data/interfaces/jobmodels';
import { NLCInfo } from '../data/interfaces/sharedmodels';

interface JobState {
    searchOutputFileInputsList: SearchOutputFileInput[];
    isStart: boolean;
    selectedNlcs:NLCInfo[]
  }

const initialState:JobState={
 isStart:true,
 
  searchOutputFileInputsList:[],
  selectedNlcs:[]
}

const JobsSlice = createSlice({
  name: 'jobsslice',
  initialState,
  reducers: {
    reset: () => initialState,
    setisStartTrue: (state) => {
      state.isStart = true;
    },
    setisStartFalse: (state) => {
      state.isStart = false;
    },
    push:(state,action)=>{
        state.searchOutputFileInputsList.push(action.payload);
    },
     pop:(state)=>{
        state.searchOutputFileInputsList.pop();
    },
    updateselectedNlcs: (state, action) => {
      state.selectedNlcs = action.payload;
    }
   
  },
});

export const { setisStartTrue, setisStartFalse,push, pop,updateselectedNlcs } = JobsSlice.actions;
export default JobsSlice.reducer;
